import { environment } from "../../environments/environment";
import { AccessControl } from "./models/accessControlRequest";
import { Injectable } from "@angular/core";

// @Injectable()
export class Resource {
  public baseurl: string;
  public accessControlUrl: string;
  public accessControlRequest: AccessControl;
  public accessControl: string;
  public paymentDetails: string;
  public createPayment: string;
  public makePayment: string;
  public hostUrl: string;
  public paymentRequery: string;
  public paymentPageDetails: string;
  public redirectUrlForMpgs: string;
  public creatMPGSeSession: string;
  public updateMPGSSession: string;
  public makeMPGSPayment: string;
  public mpgsBaseUrl: string;
  public ghbaseurl: string;
  public checkoutSettings: string;
  public createRating: string;
  public payWithTransfer: string;
  public initiateBankTransaction: string;
  public confirmTransfer: string;
  public cpsUrl: string;
  public getBanksList: string;
  public initiateCard: string;
  validateCollection = "/api/cps/v1/collection/validate";
  collectionNotification = "/api/cps/v1/collection/notify";

  constructor() {
    this.baseurl = environment.url;
    this.redirectUrlForMpgs = environment.redirectUrlForMpgs;
    this.accessControlRequest = {
      duration: "3900",
      accessType: "",
      appName: "",
      plainText: true,
    };
    this.accessControlUrl = environment.accessControl;
    this.accessControl = "/api/pgs/public/v1/token";
    this.paymentDetails = "/api/pgs/admin/payment/v1/paymentPage";
    this.makePayment = "/api/pgs/admin/payment/v1/makePayment";
    this.hostUrl = environment.hostUrl;
    this.paymentRequery = "/api/pgs/admin/payment/v1/getPaymentDetails/";
    this.paymentPageDetails =
      "/api/pgs/admin/payment/v1/getPaymentPageDetails/";
    this.createPayment = "/api/pgs/payment/v2/createPayment"; //called after calling the getpaymentpagedetails
    this.creatMPGSeSession = "/api/cps/v1/mastercard/createSession";
    this.updateMPGSSession = "/api/cps/v1/mastercard/updateSession";
    this.makeMPGSPayment = "/api/cps/v1/mastercard/makePayment";
    this.mpgsBaseUrl = environment.ghMPGS;
    this.ghbaseurl = environment.ghurl;
    this.checkoutSettings = "/api/pgs/clients/v1/checkoutSettings";
    this.createRating = "/api/rexpay/v1/rating/create";
    this.payWithTransfer = "/api/cps/v1/initiateBankTransfer";
    this.initiateBankTransaction = "/api/cps/v1/initiateBankTransaction";
    this.confirmTransfer = "/api/cps/v1/getTransactionStatus";
    this.getBanksList = "/api/cps/v1/banks";
    this.cpsUrl = environment.cpsUrl;
    this.initiateCard = "/api/cps/v1/initiateCard";
  }
}
